import * as ActionTypes from './ActionTypes'

/**
 * Open the Dialog (popup) that shows the
 * @param {Boolean} open - True - opens it, False, closes it
 */
export function setConfirmPaymentDialog(open) {
  return (dispatch) => {
    dispatch({
      type: ActionTypes.VNDIALOGS_CONFIRM_PAYMENT_READY,
      dialog: open,
    })
  }
}

export function setDebugDialogOpen(open) {
  return (dispatch) => {
    dispatch({
      type: ActionTypes.VN_DEBUG_DIALOG,
      dialog: open,
    })
  }
}

/**
 * Open the Dialog (popup) that shows the
 * @param {Boolean} open - True - opens it, False, closes it
 */
export function setCFDPairedDialogOpen(open) {
  return (dispatch) => {
    dispatch({
      type: ActionTypes.VNDIALOGS_CFD_PAIRED_DIALOG,
      dialog: open,
    })
  }
}

/**
 * Generic Confirmation Dialog
 *
 * @param {String} title
 * @param {?String} message
 * @param {?Function} onConfirm
 * @returns
 */
export function setConfirmationDialog(title, message = null, onConfirm = null, confirmText = 'CONFIRM') {
  return (dispatch) => {
    dispatch({
      type: ActionTypes.VNDIALOGS_CONFIRMATION_DIALOG,
      dialog: {
        open: !!title,
        title,
        message,
        onConfirm,
        confirmText,
      },
    })
  }
}

export function setVNTipEntryDialog(
  open,
  onSubmit,
  initialValue,
  title = 'Custom Tip',
  isKiosk = false,
  saveButtonText = 'Save',
  isCfd = false,
) {
  return (dispatch) => {
    dispatch({
      type: ActionTypes.VNDIALOGS_VN_TIP_ENTRY_DIALOG,
      dialog: {
        open,
        onSubmit,
        initialValue,
        title,
        isKiosk,
        saveButtonText,
        isCfd,
      },
    })
  }
}

export function setEnteringInputDialog({
  open,
  onSave,
  onSaveText = 'Save',
  onCancelText = 'Cancel',
  title = 'Enter Input',
  subTitle = '',
  maxLength = 255,
  type = 'text',
  defaultValue = '',
  multiLine = false,
  preselect = true, // Whether to highlight all of the text in the input field when the dialog opens
  regexExpression = null,
}) {
  return (dispatch) => {
    dispatch({
      type: ActionTypes.VN_ENTERING_INPUT_DIALOG,
      dialog: {
        open,
        type,
        title,
        onSave,
        subTitle,
        maxLength,
        defaultValue,
        onSaveText,
        onCancelText,
        multiLine,
        preselect,
        regexExpression,
      },
    })
  }
}

export function setMobileScanPaymentDialog(open, scanTender = null, tenderAmountInCents = null, displayName = '') {
  return (dispatch) => {
    dispatch({
      type: ActionTypes.MOBILE_SCAN_PAYMENT_DIALOG,
      data: {
        scanTender,
        displayName,
        tenderAmountInCents,
        open,
      },
    })
  }
}

/**
 * Open the Dialog (popup) that shows an
 * @param {Object} dialogOptions - True - opens it, False, closes it
 */
export function setOpenCustomerPaymentDialog(dialogOptions) {
  return (dispatch) => {
    dispatch({
      type: ActionTypes.VNDIALOGS_CUSTOMER_PAYMENT,
      dialog: dialogOptions,
    })
  }
}

/**
 * Open the Dialog (popup) that shows an
 * @param {Boolean} open - True - opens it, False, closes it
 */
export function setCustomerViewingReceiptDialog(dialogOptions) {
  return (dispatch) => {
    dispatch({
      type: ActionTypes.VNDIALOGS_CUSTOMER_VIEWING_RECEIPT,
      dialog: dialogOptions,
    })
  }
}

/**
 * Open the Dialog (popup) that shows an
 * @param {Object} dialogOptions - True - opens it, False, closes it
 */
export function setCustomerPayingWithCard(dialogOptions) {
  return (dispatch) => {
    dispatch({
      type: ActionTypes.VNDIALOGS_CUSTOMER_PAYING_WITH_CARD,
      dialog: dialogOptions,
    })
  }
}

/**
 * Open the Dialog (popup) that shows an
 * @param {Boolean} open - True - opens it, False, closes it
 */
export function setTransactionCompleteDialog(open) {
  return (dispatch) => {
    dispatch({
      type: ActionTypes.VNDIALOGS_TRANSACTION_COMPLETE,
      dialog: open,
    })
  }
}

/**
 * @param {Object} dialogOptions the options required for the dialog
 * dialogOptions = {
 *  open: Boolean,
 *  subTitle: JSX.Element or String,
 * }
 */
export function setTransactionErrorDialog(dialogOptions) {
  return (dispatch) => {
    dispatch({
      type: ActionTypes.VNDIALOGS_TRANSACTION_ERROR,
      dialog: dialogOptions,
    })
  }
}

/**
 * @param {Object} dialogOptions the options required for the dialog
 * dialogOptions = {
 *  open: Boolean,
 *  amount: Number,
 *  tipsEnabled: Boolean
 * }
 */
export function setOpenCustomerEnteringTipDialog(dialogOptions) {
  return (dispatch) => {
    dispatch({
      type: ActionTypes.VNDIALOGS_CUSTOMER_ENTERING_TIP,
      dialog: dialogOptions,
    })
  }
}

/**
 * @param {Object} dialogOptions the options required for the dialog
 * dialogOptions = {
 *  open: Boolean,
 *  amount: String
 * }
 */
export function setCardAuthStepOne(dialogOptions) {
  return (dispatch) => {
    dispatch({
      type: ActionTypes.VNDIALOGS_CARD_AUTH_STEP_ONE,
      dialog: dialogOptions,
    })
  }
}

/**
 * @param {Object} dialogOptions the options required for the dialog
 * dialogOptions = {
 *  open: Boolean,
 *  amount: String
 * }
 */
export function setCardAuthStepTwo(dialogOptions) {
  return (dispatch) => {
    dispatch({
      type: ActionTypes.VNDIALOGS_CARD_AUTH_STEP_TWO,
      dialog: dialogOptions,
    })
  }
}

/**
 * @param {Boolean} open whether to open or close the dialog
 */
export function setKitchenPrintErrorDialogOpen(open) {
  return (dispatch) => {
    dispatch({
      type: ActionTypes.VNDIALOGS_KITCHEN_PRINTER_ERROR_DIALOG,
      dialog: open,
    })
  }
}

/**
 * BackBar Finalize Tip and Confirm Dialogs
 *
 * @param {Boolean} open
 */
export function setBackBarFinalizeModals(open) {
  return (dispatch) => {
    dispatch({
      type: ActionTypes.VNDIALOGS_BACK_BAR_FINALIZE_MODALS,
      dialog: open,
    })
  }
}

/**
 * Dialog when attemping to print to a network printer while offline
 *
 * @link https://www.figma.com/design/c2daBWS1vGCMSVb1zfSQpO/Quick-Service?node-id=13407-56149
 * @param {Boolean} open whether to open or close the dialog
 * @param {String} message error message to show in the dialog
 */
export function SetOfflineDialog(open, message) {
  return (dispatch) => {
    dispatch({
      type: ActionTypes.VNDIALOGS_OFFLINE_DIALOG,
      dialog: { open, message },
    })
  }
}

/**
 * Dialog when attempting navigate to a different screen while syncing
 *
 * @param {Object} options open: whether to open or close the dialog || callback: callable function before closing the dialog
 */
export function setSyncWarningDialog(open, callback = () => {}) {
  return (dispatch) => {
    dispatch({
      type: ActionTypes.VNDIALOGS_STOP_SYNC_DIALOG,
      options: {
        open,
        callback,
      },
    })
  }
}

/**
 * Dialog when attempting to print to a network printer while offline
 *
 * @link https://www.figma.com/design/c2daBWS1vGCMSVb1zfSQpO/Quick-Service?node-id=13407-56149
 * @param {Object} options open: whether to open or close the dialog || subtext: change the default text to something else
 */
export function setConnectionRequiredDialog(options) {
  return (dispatch) => {
    dispatch({
      type: ActionTypes.VNDIALOGS_CONNECTION_REQUIRED_DIALOG,
      dialog: options,
    })
  }
}

/**
 * Dialog when attempting balance lookup
 *
 * @link https://www.figma.com/design/c2daBWS1vGCMSVb1zfSQpO/Quick-Service?m=auto&node-id=8322-37211&t=0Dp6s3Mip0FZFv2t-1
 * @param {Object} options should contain open and amount.
 */
export function setBalanceLookupDialogOptions(options) {
  return (dispatch) => {
    dispatch({
      type: ActionTypes.VNDIALOGS_BALANCE_LOOKUP,
      options: options,
    })
  }
}

/**
 * Dialog when attempting to print refund and no printer is configured
 *
 * @link https://www.figma.com/design/c2daBWS1vGCMSVb1zfSQpO/Quick-Service?t=2rlmOpuujIAzSu53-0
 * @param {Object} options open: whether to open or close the dialog || subtext: change the default text to something else
 */
export function setPrinterNotConfiguredDialog(options) {
  return (dispatch) => {
    dispatch({
      type: ActionTypes.VNDIALOGS_PRINTER_NOT_CONFIGURED_DIALOG,
      options,
    })
  }
}

/**
 * Rich Checkout is not supported for Open Price items at this point
 * This informs the user that proceeding with the checkout will drop any custom pricing
 * @link https://shift4.atlassian.net/wiki/spaces/venuenext/pages/1551138817/POS+Open+Priced+Items+Requirements
 * @param {Boolean} open - open or close the dialog
 * @param {Boolean} title - the message shown to the user
 * @returns {Function}
 */
export function setBlockRichCheckoutOrderDialog(open = true, title = '') {
  return (dispatch) => {
    dispatch({
      type: ActionTypes.VNDIALOGS_OPEN_PRICE_RICH_CHECKOUT_NOT_SUPPORTED,
      options: { open, title },
    })
  }
}

/**
 * Price Adjust ("Override") Dialog
 * @link https://shift4.atlassian.net/wiki/spaces/venuenext/pages/1551138858/
 * @param {Boolean} open - open or close the dialog
 * @param {?Number} current - current price
 * @param {?Number} latest - latest price
 * @returns {Function}
 */
export function setPriceAdjustDialog(open, current = null, latest = null) {
  return (dispatch) => {
    dispatch({
      type: ActionTypes.VNDIALOGS_PRICE_ADJUSTMENT_DIALOG,
      options: { open, current, latest },
    })
  }
}

/**
 * Price Adjust ("Override") Exiting from without updating item dialog
 * @link https://shift4.atlassian.net/wiki/spaces/venuenext/pages/1551138858/
 * @param {Boolean} open - open or close the dialog
 * @returns {Function}
 */
export function setPriceAdjustExitConfirmation(open = true, fromViewItemDetail = false, closeVNViewItemDetail = () => {}) {
  return (dispatch) => {
    dispatch({
      type: ActionTypes.VNDIALOGS_PRICE_ADJUSTMENT_CONFIRM_EXIT,
      options: { open, fromViewItemDetail, closeVNViewItemDetail },
    })
  }
}

/**
 * Dialog when attempting to re open a tab that can't be opened
 *
 * @param {Object} options open: whether to open or close the dialog
 */
export function setCannotReopenTabDialog(options) {
  return (dispatch) => {
    dispatch({
      type: ActionTypes.VNDIALOGS_CANNOT_REOPEN_TAB_DIALOG,
      options,
    })
  }
}

/**
 * Dialog to confirm if the user wants to reopen a tab
 *
 * https://www.figma.com/design/c2daBWS1vGCMSVb1zfSQpO/Quick-Service?node-id=24129-34143&t=eimhJRn5XPFQECxP-0
 * @param {Object} options open: whether to open or close the dialog
 */
export function setReopenTabDialog(options) {
  return (dispatch) => {
    dispatch({
      type: ActionTypes.VNDIALOGS_REOPEN_TAB_DIALOG,
      options,
    })
  }
}

/**
 * Dialog to confirm if the user wants to reopen a tab
 *
 * https://www.figma.com/design/c2daBWS1vGCMSVb1zfSQpO/Quick-Service?node-id=24129-34143&t=eimhJRn5XPFQECxP-0
 * @param {Object} options open: whether to open or close the dialog
 */
export function setCannotReopenUnsyncedTabDialog(options) {
  return (dispatch) => {
    dispatch({
      type: ActionTypes.VNDIALOGS_CANNOT_REOPEN_UNSYNCED_TAB,
      options,
    })
  }
}

/**
 * CFD Communication Error Dialog
 *
 * @param {Boolean} open
 */
export function setMessageReceiptErrorDialog(open = true) {
  return (dispatch) => {
    dispatch({
      type: ActionTypes.VN_SET_MESSAGE_RECEIPT_ERROR_DIALOG,
      options: { open },
    })
  }
}

export function setCFDNotPairedDialog(open = true) {
  return (dispatch) => {
    dispatch({
      type: ActionTypes.VN_DIALOGS_CFD_NOT_PAIRED_DIALOG,
      options: { open },
    })
  }
}

export function setCFDBlockingDialog(message = null) {
  return (dispatch) => {
    dispatch({
      type: ActionTypes.VNDIALOGS_CFD_BLOCKING_DIALOG,
      options: { message },
    })
  }
}

/**
 * Dialog when attempting to re open a tab that can't be opened
 *
 * @param {Object} options open: whether to open or close the dialog
 */
export function setTaxDisplayDialog(options) {
  return (dispatch) => {
    dispatch({
      type: ActionTypes.VNDIALOGS_TAX_DISPLAY_DIALOG,
      options,
    })
  }
}

export function setStartATabModal({ open, initialInputValue = '', onSaveClick, tabNameInputRef }) {
  return (dispatch) => {
    dispatch({
      type: ActionTypes.VN_START_A_TAB_MODAL,
      dialog: {
        open,
        initialInputValue,
        onSaveClick,
        tabNameInputRef,
      },
    })
  }
}

export function setTabPaymentMethodModal({
  open,
  handleAuthorizePaymentRequest,
  onCloseDialog,
  shouldShowAddPaymentLater = true,
  preAuthorizedCardName = '',
  handlePreAuthorizedCard,
  handleAddPaymentLater,
  newOrderDetails = {},
  authNewText = false,
}) {
  return (dispatch) => {
    dispatch({
      type: ActionTypes.VN_TAB_PAYMENT_METHOD_MODAL,
      dialog: {
        open,
        handleAuthorizePaymentRequest,
        onCloseDialog,
        shouldShowAddPaymentLater,
        handleAddPaymentLater,
        handlePreAuthorizedCard,
        preAuthorizedCardName,
        newOrderDetails,
        authNewText,
      },
    })
  }
}
export function setConfirmDefaultTipModal({
  open,
  onConfirm = () => {},
  onCancel = () => {},
  initialTipPercentage,
  isKiosk = false,
}) {
  return (dispatch) => {
    dispatch({
      type: ActionTypes.CONFIRM_DEFAULT_TIP_MODAL,
      dialog: {
        open,
        onConfirm,
        onCancel,
        initialTipPercentage,
        isKiosk,
      },
    })
  }
}

export function setTransferTabModal({ open, order }) {
  return (dispatch) => {
    dispatch({
      type: ActionTypes.VN_TRANSFER_TAB_MODAL,
      dialog: {
        open,
        order,
      },
    })
  }
}

export function setCashPaymentAlreadyAppliedModal(options) {
  return (dispatch) => {
    dispatch({
      type: ActionTypes.VN_CASH_PAYMENT_ALREADY_APPLIED_MODAL,
      options,
    })
  }
}

export function setMobileQRReceiptDialog({ open, qrCode, total, onBack, onClose }) {
  return (dispatch) => {
    dispatch({
      type: ActionTypes.VN_MOBILE_QR_RECEIPT_DIALOG,
      dialog: {
        open,
        qrCode,
        total,
        onBack,
        onClose,
      },
    })
  }
}
